var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 22 14.8",
    style: {
      enableBackground: "new 0 0 22 14.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#EFEDEA;}\n\t.st1{fill:#CCCBCA;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_7_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_8_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_10_",
    className: "st0",
    d: "M1.7,0.9l7.9,6C10,7.2,10.5,7.3,11,7.3c0.5,0,1-0.1,1.3-0.4l7.9-6C20.9,0.4,20.7,0,19.9,0H11 H2.1C1.3,0,1.1,0.4,1.7,0.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_9_",
    className: "st1",
    d: "M20.8,2.5l-8.7,6.3C11.8,9,11.4,9.2,11,9.1c-0.4,0-0.8-0.1-1.2-0.3L1.2,2.5C0.5,2,0,2.3,0,3 v10.4c0,0.8,0.7,1.4,1.5,1.4H11h9.5c0.8,0,1.5-0.6,1.5-1.4V3C22,2.3,21.5,2,20.8,2.5z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.686de5837ffb3373db5e56f2d5c5f029.svg";
export { ForwardRef as ReactComponent };